import React, { useState } from 'react';
import depositpic from "../../../../assets/images/depositmodal.png";
import Button from '../../Button/Button';
import LegalDisclosures from '../LegalDisclosures/LegalDisclosures';
import Modal from '../Modal/Modal';
import styles from "./DirectDeposit.module.scss";

const DirectDeposit = ({ show, handleClose }) => {
    const [showLegalDisclosures, setShowLegalDisclosures] = useState(false);
    return (
        <>
            <Modal
                className={styles.deposit_modal}
                show={show}
                handleClose={handleClose}
                title="Direct Deposit"
            >
                <div className={styles.direct_sec}>
                    <div className={styles.deposit_img}>
                        <img src={depositpic} alt="deposit" />
                    </div>
                    <h2>Get your paycheck deposited <br />
                        into STBL</h2>
                    <p>If you choose to get paid in STBL tokens, STBL will automatically convert your paycheck from US dollars to STBL tokens with no trading fees on direct deposit.</p>
                </div>
                <Button
                    fluid
                    className={styles.submit_btn}
                    onClick={() => { setShowLegalDisclosures(true); handleClose() }}
                >Get Started</Button>
            </Modal>
            <LegalDisclosures
                show={showLegalDisclosures}
                handleClose={() => setShowLegalDisclosures(false)}
            />
        </>
    )
}

export default DirectDeposit